import './Checkbox.scss'

// Define the checkbox component props interface
interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  // Add any additional checkbox-specific props here
  checked: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  ...props
}) => {
  return (
    <label className="CLCheckbox">
      <input
        className="CLCheckbox__input"
        type="checkbox"
        checked={checked}
        onChange={onChange}
        {...props}
      />
      <span className="CLCheckbox__check"></span>
    </label>
  )
}
